<div *ngIf="prikaziStranicu" class="container-fluid">
  <h2 class="content-block">MAKSIMALNI KAPACITET LINIJA PO PROIZVODU</h2>

  <dx-button
    [disabled]="pravaZaTrenutniPogled != 2"
    class="button-info mbx-40"
    text="Dodaj liniju"
    (onClick)="dodajLinijuPopup()">
  </dx-button>

  <dx-popup
    [width]="450"
    [height]="'auto'"
    [showTitle]="true"
    title="Dodavanje linije!"
    [dragEnabled]="false"
    [closeOnOutsideClick]="false"
    [(visible)]="dodajLinijuPopupVisible">

    <div *dxTemplate="let data of 'content'">
      <div class="input-popup">
        <dx-text-box
          placeholder="Unesite naziv linije..."
          [value]="noviNazivLinije"
          (onValueChanged)="promjenaNazivaLinije($event)">
        </dx-text-box>
      </div>
      <div class="input-popup floating-placeholder">
        <!--
        <dx-text-box
          placeholder="Odgovorna osoba"
          [value]="odgovorneOsobe"
          (onValueChanged)="promjenaOdgovorneOsobe($event)">
        </dx-text-box>
        -->
        <dx-tag-box
          [dataSource]="djelatnici"
          [value]="odgovorneOsobe"
          displayExpr="name"
          placeholder="Ime odgovorne osobe"
          [searchEnabled]="true"
          [searchExpr]="['name']"
          (onValueChanged)="changeOdgovornaOsoba($event)"
          [hideSelectedItems]="true">
        </dx-tag-box>
      </div>
      <div class="input-popup floating-placeholder">
        <dx-number-box
          [value]="cijenaStruje"
          placeholder="Cijena kW po minuti"
          (onValueChanged)="promjenaCijeneStruje($event)">
        </dx-number-box>
      </div>
      <div class="input-popup floating-placeholder">
        <dx-number-box
          [value]="cijenaPlina"
          placeholder="Cijena plina za m3"
          (onValueChanged)="promjenaCijenePlina($event)">
        </dx-number-box>
      </div>
      <div class="input-popup floating-placeholder">
        <dx-number-box
          [value]="cijenaVode"
          placeholder="Cijena vode za m3"
          (onValueChanged)="promjenaCijeneVode($event)">
        </dx-number-box>
      </div>
      <div class="input-popup floating-placeholder">
        <dx-number-box
          [value]="cijenaOTP"
          placeholder="OTP u KN po minut"
          (onValueChanged)="promjenaCijeneOTP($event)">
        </dx-number-box>
      </div>
      <div class="input-popup floating-placeholder">
        <dx-select-box
          [dataSource]="skladista"
          [value]="odabranoSkladiste"
          displayExpr="po_naziv"
          valueExpr="idposlovnica"
          placeholder="Odaberi skladište sirovinaa"
          [searchEnabled]="true"
          [searchExpr]="['po_sifra', 'po_naziv']"
          (onValueChanged)="odaberiSkladiste($event)">
        </dx-select-box>
      </div>
      <div class="input-popup floating-placeholder">
        <dx-select-box
          [dataSource]="skladistaGotovihProizvoda"
          [value]="odabranoGotovoSkladiste"
          displayExpr="po_naziv"
          valueExpr="idposlovnica"
          placeholder="Odaberi skladište gotovih proizvodaa"
          [searchEnabled]="true"
          [searchExpr]="['po_sifra', 'po_naziv']"
          (onValueChanged)="odaberiGotovoSkladiste($event)">
        </dx-select-box>
      </div>
      <div class="input-popup floating-placeholder">
        <dx-select-box
          [dataSource]="skladistaAmbalaze"
          [value]="odabranoSkladisteAmbalaze"
          displayExpr="sifrainaziv"
          valueExpr="idposlovnica"
          placeholder="Odaberi skladište ambalaže"
          [searchEnabled]="true"
          [searchExpr]="['po_sifra', 'po_naziv']"
          (onValueChanged)="odaberiSkladisteAmbalaze($event)">
        </dx-select-box>
      </div>
      <div class="input-popup floating-placeholder">
        <dx-select-box
          [dataSource]="pogoni"
          [value]="odabraniPogon"
          displayExpr="pogon_naziv"
          valueExpr="idpogon"
          placeholder="Odaberi pogon"
          [searchEnabled]="true"
          [searchExpr]="['pogon_naziv']"
          (onValueChanged)="odabranPogon($event)">
        </dx-select-box>
      </div>
      <dx-button class="button-info" text="DODAJ" (onClick)="dodajLiniju()"></dx-button>
      <p *ngIf="bezNaziva" class="error">Unesite naziv linije!</p>
    </div>
  </dx-popup>

  <dx-popup
    [disabled]="pravaZaTrenutniPogled != 2"
    [width]="450"
    [height]="'auto'"
    [showTitle]="true"
    title="Uređivanje podataka!"
    [dragEnabled]="false"
    [closeOnOutsideClick]="false"
    [(visible)]="promjeniNazivPopupVisible">

    <div *dxTemplate="let data of 'content'">
      <div class="input-popup">
        <dx-text-box
          value="{{ objektLinija.naziv }}"
          (onValueChanged)="promjenaNazivaLinije($event)">
        </dx-text-box>
      </div>

      <!-- <div class="input-popup floating-placeholder">
        <dx-text-box
          value="{{ objektLinija.odgovornaOsoba }}"
          placeholder="Odgovorna osoba"
          (onValueChanged)="promjenaOdgovorneOsobe($event)"
        >
        </dx-text-box>
      </div> -->

      <div class="input-popup floating-placeholder">
        <dx-tag-box
          [dataSource]="djelatniciNaLiniji"
          [value]="dodaniDjelatnici"
          displayExpr="name"
          placeholder="Ime odgovorne osobe"
          [searchEnabled]="true"
          [searchExpr]="['name']"
          (onValueChanged)="promjenaOdgovorneOsobe($event)"
          [hideSelectedItems]="true">
        </dx-tag-box>
      </div>

      <div class="input-popup floating-placeholder">
        <dx-number-box
          [value]="cijenaStruje"
          placeholder="Cijena kW po minuti"
          (onValueChanged)="promjenaCijeneStruje($event)">
        </dx-number-box>
      </div>

      <div class="input-popup floating-placeholder">
        <dx-number-box
          [value]="cijenaPlina"
          placeholder="Cijena plina za m3"
          (onValueChanged)="promjenaCijenePlina($event)">
        </dx-number-box>
      </div>

      <div class="input-popup floating-placeholder">
        <dx-number-box
          [value]="cijenaVode"
          placeholder="Cijena vode za m3"
          (onValueChanged)="promjenaCijeneVode($event)">
        </dx-number-box>
      </div>

      <div class="input-popup floating-placeholder">
        <dx-number-box
          [value]="cijenaOTP"
          placeholder="OTP u KN po minut"
          (onValueChanged)="promjenaCijeneOTP($event)">
        </dx-number-box>
      </div>

      <div class="input-popup floating-placeholder">
        <dx-select-box
          [dataSource]="skladista"
          displayExpr="sifrainaziv"
          [value]="objektLinija.idSkladista"
          valueExpr="idposlovnica"
          placeholder="Odaberi skladište sirovina"
          [searchEnabled]="true"
          [searchExpr]="['po_sifra', 'po_naziv']"
          (onValueChanged)="odaberiSkladiste($event)">
        </dx-select-box>
      </div>

      <div class="input-popup floating-placeholder">
        <dx-select-box
          [dataSource]="skladistaGotovihProizvoda"
          [value]="objektLinija.idSkladistaGotovo"
          displayExpr="sifrainaziv"
          valueExpr="idposlovnica"
          placeholder="Odaberi skladište gotovih proizvoda"
          [searchEnabled]="true"
          [searchExpr]="['po_sifra', 'po_naziv']"
          (onValueChanged)="odaberiGotovoSkladiste($event)">
        </dx-select-box>
      </div>

      <div class="input-popup floating-placeholder">
        <dx-select-box
          [dataSource]="skladistaAmbalaze"
          [value]="objektLinija.idSkladistaAmbalaza"
          displayExpr="sifrainaziv"
          valueExpr="idposlovnica"
          placeholder="Odaberi skladište ambalaže"
          [searchEnabled]="true"
          [searchExpr]="['po_sifra', 'po_naziv']"
          (onValueChanged)="odaberiSkladisteAmbalaze($event)">
        </dx-select-box>
      </div>

      <div class="input-popup floating-placeholder">
        <dx-select-box
          [dataSource]="pogoni"
          [value]="objektLinija.idPogon"
          displayExpr="pogon_naziv"
          valueExpr="idpogon"
          placeholder="Odaberi pogon"
          [searchEnabled]="true"
          [searchExpr]="['pogon_naziv']"
          (onValueChanged)="odabranPogon($event)">
        </dx-select-box>
      </div>

      <dx-button class="button-info" text="PROMJENI" (onClick)="urediLiniju()"></dx-button>

      <p *ngIf="bezNaziva" class="error">Unesite naziv linije!</p>
    </div>
  </dx-popup>

  <dx-popup
    [disabled]="pravaZaTrenutniPogled != 2"
    [width]="350"
    [height]="'auto'"
    [showTitle]="true"
    title="Brisanje linije!"
    [dragEnabled]="false"
    [closeOnOutsideClick]="false"
    [(visible)]="brisanjeLinijePopupVisible">

    <div *dxTemplate="let data of 'content'">
      <p>Sigurno želite obrisati liniju <strong>"{{ objektLinija.naziv }}"</strong>?</p>
      <dx-button class="button-info" text="DA" (onClick)="obrisiLiniju()"></dx-button>
      <dx-button class="button-info" text="NE" (onClick)="zatvoriPopup()"></dx-button>
    </div>
  </dx-popup>

  <ul class="grid-list">
    <li
      *ngFor="let linija of arrayLinije"
      class="grid-item"
      [class.active]="odabranaLinija === linija.id"
      (click)="odabirLinije($event, linija.id)">
      {{ linija.naziv }}
      <div *ngIf="linija.odgovornaOsoba"
        style="
          font-size: 15px;
          color: #aaa;
          font-weight: normal;
          line-height: 1.5;
        " >
        Odgovorna osoba: {{ linija.odgovornaOsoba }}
      </div>
      <div *ngIf="linija.nazivSkladista"
        style="
          font-size: 15px;
          color: #aaa;
          font-weight: normal;
          line-height: 1.5;
        ">
        Skladište: {{ linija.nazivSkladista }}
      </div>
      <dx-button id="menuLinija" icon="overflow" (onClick)="podaciLinija(linija)"></dx-button>
      <dx-context-menu
        [dataSource]="menuItems"
        [width]="200"
        target="#menuLinija"
        showEvent="dxclick"
        [(visible)]="isContextMenuVisible"
        (onItemClick)="itemClick($event)">
      </dx-context-menu>
    </li>
  </ul>

  <!-- <ul class="grid-list">
    <li class="grid-item" (click)="odabirLinije($event, 1)">Linija 1</li>
    <li class="grid-item" (click)="odabirLinije($event, 2)">Linija 2</li>
    <li class="grid-item" (click)="odabirLinije($event, 3)">Linija 3</li>
    <li class="grid-item" (click)="odabirLinije($event, 4)">Linija 4</li>
    <li class="grid-item" (click)="odabirLinije($event, 5)">Linija 5</li>
    <li class="grid-item" (click)="odabirLinije($event, 6)">Linija 6</li>
    <li class="grid-item" (click)="odabirLinije($event, 7)">Linija 7</li>
    <li class="grid-item" (click)="odabirLinije($event, 8)">Linija 8</li>
</ul> -->

  <dx-popup
    [width]="300"
    [height]="250"
    [showTitle]="true"
    title="Spremi promjene!"
    [dragEnabled]="false"
    [closeOnOutsideClick]="false"
    [(visible)]="popupChanges">
    <div *dxTemplate="let data of 'content'">
      <p>Promjene nisu spremljene, želite li ih sačuvati prije prebacivanja na drugu liniju?</p>
      <dx-button class="button-info" text="DA" (onClick)="popupSpremi()"></dx-button>
      <dx-button class="button-info" text="NE" (onClick)="popupOtkazi()"></dx-button>
    </div>
  </dx-popup>

  <div *ngIf="odabranaLinija" class="customTable kapacitetLinija m-40">
    <div id="data-grid-demo">
      <dx-data-grid
        [disabled]="pravaZaTrenutniPogled != 2"
        #dataGrid
        id="gridContainer"
        [dataSource]="linijaProizvodi"
        [showColumnLines]="true"
        noDataText="Nema proizvoda"
        [wordWrapEnabled]="true"
        keyExpr="sifra"
        [showBorders]="false"
        (onRowUpdated)="onRowUpdated($event)"
        (onRowRemoving)="obrisiProizvod($event)"
        (onToolbarPreparing)="onToolbarPreparing($event)">

        <div *dxTemplate="let data of 'naslovTablice'">
          <div class="naslov">
            <h2>
              Unos maksimalnih količina proizvoda po smjeni
              <div class="d-inline ml-15">
                <dx-button icon="plus" hint="Dodaj proizvod" stylingMode="outlined" type="success" (click)="otvoriPopup()"></dx-button>
                <dx-popup
                  [width]="600"
                  [height]="300"
                  [showTitle]="true"
                  title="Dodaj proizvod"
                  [dragEnabled]="false"
                  [closeOnOutsideClick]="true"
                  [(visible)]="popupVisible">
                  <div>
                    <div class="dx-field">
                      <!-- <div class="dx-field-label">Proizvod</div> -->
                      <div class="dx-field-value w-100">
                        <dx-select-box
                          #selectBox
                          [dataSource]="sviProizvodi"
                          displayExpr="sifraNaziv"
                          valueExpr="id"
                          placeholder="Odaberi proizvod"
                          [searchEnabled]="true"
                          [searchExpr]="['sifra', 'naziv']"
                          (onValueChanged)="odaberiProizvod($event)">
                        </dx-select-box>
                      </div>
                    </div>
                    <div class="dx-field">
                      <!-- <div class="dx-field-label">Količina</div> -->
                      <div class="dx-field-value w-100">
                        <dx-number-box
                          #numberBox
                          placeholder="Količina"
                          (onValueChanged)="odaberiKolicinu($event)">
                        </dx-number-box>
                      </div>
                    </div>
                    <div *ngIf="poruka" class="dx-field error-message">
                      {{ poruka }}
                    </div>
                    <div class="dx-field float-right">
                      <dx-button
                        stylingMode="contained"
                        text="Dodaj"
                        type="success"
                        [width]="120"
                        (onClick)="dodajProizvod()">
                      </dx-button>
                    </div>
                  </div>
                </dx-popup>
              </div>
            </h2>
          </div>
        </div>

        <dxo-search-panel
          [visible]="true"
          [width]="240"
          placeholder="Pretraži...">
        </dxo-search-panel>

        <dxo-paging [enabled]="true" [pageSize]="20"></dxo-paging>

        <dxo-pager
          [showPageSizeSelector]="true"
          [allowedPageSizes]="[10, 20, 30]"
          [showInfo]="true">
        </dxo-pager>

        <dxo-editing
          mode="batch"
          [allowUpdating]="true"
          [allowDeleting]="true"
          [selectTextOnEditStart]="selectTextOnEditStart"
          [startEditAction]="startEditAction">
        </dxo-editing>

        <dxi-column
          dataField="sifra"
          caption="Šifra"
          [width]="150"
          [allowEditing]="false">
        </dxi-column>
        <dxi-column
          dataField="naziv"
          caption="Naziv"
          [allowEditing]="false">
        </dxi-column>
        <dxi-column
          dataField="maksimum"
          caption="Maksimalna količina proizvodnje po smjeni"
          [width]="200">
        </dxi-column>
      </dx-data-grid>
    </div>
  </div>
</div>
